/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".actions[_ngcontent-%COMP%]{text-align:center}.service-desk-alert[_ngcontent-%COMP%]{margin:1rem}.cancel[_ngcontent-%COMP%]{font-size:.815rem}"];
export { styles as styles };
